<gene-drawer [id]="drawerId" position="right" header="Reference" subheader="These are the sources Gene.AI used to reference the response."
    (close)="onDrawerClosed()">
    <div class="references-body-wrapper">
        <ng-container *ngIf="sources && sources.length; else noReferences">
            <h4 class="reference-count">{{sourceCountLabel}}</h4>
            <div *ngFor="let source of sources" class="reference-item-wrapper">
                <app-reference-drawer-item [info]="source" />
            </div>
        </ng-container>
        <ng-template #noReferences>
            <p class="no-references">No references available.</p>
        </ng-template>
    </div>
</gene-drawer>
